import { z } from 'zod';
import { TopicSchema } from './topic.js';
import { ActionItemSchema } from './actionItem.js';
import { AttendeeGroupSchema } from './attendee.js';
export const MeetingFormatSchema = z.enum(['in_person', 'video', 'phone', 'hybrid']);
export const MeetingStatusSchema = z.enum(['draft', 'finalized', 'soft_deleted']);
export const InputSourceSchema = z.enum(['transcript', 'ai_summary', 'freeform']);
export const TemplateVariantSchema = z.enum(['client_meeting', 'internal']);
/**
 * The structured content of a meeting — what Claude emits and what the editor renders.
 * Stored as `meetings.structured_content` in Postgres.
 */
export const StructuredContentSchema = z.object({
    title: z.string().min(1),
    meetingFormat: MeetingFormatSchema,
    location: z.string().optional(),
    meetingDate: z.string(), // ISO "YYYY-MM-DD"
    notesDate: z.string(),
    project: z.string().min(1),
    templateVariant: TemplateVariantSchema.default('client_meeting'),
    attendeeGroups: z.array(AttendeeGroupSchema),
    topics: z.array(TopicSchema),
    actionItems: z.array(ActionItemSchema),
});
export const MeetingSchema = z.object({
    id: z.string().uuid(),
    createdByUserId: z.string().uuid(),
    ownerUserId: z.string().uuid(),
    status: MeetingStatusSchema,
    inputSource: InputSourceSchema,
    rawInput: z.string(),
    structuredContent: StructuredContentSchema,
    clientVersionContent: StructuredContentSchema.optional(),
    emailSummaryText: z.string().optional(),
    graphEventId: z.string().optional(),
    finalizedAt: z.string().datetime().optional(),
    deletedAt: z.string().datetime().optional(),
    version: z.number().int().positive(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=meeting.js.map